import React from "react";
import { map, isEmpty, find, get } from "lodash";
import { Row, Col } from "react-bootstrap";
import { BsBriefcase } from "react-icons/bs";

import ContributionSource from "./ContributionSource";
import ActionCard from "components/ActionCard";
import AddEmployerModal from "./AddEmployerModal";

interface ContributionChangeRequest {
  status?: string;
  userNewContributionAmount?: number;
}

interface EmployerContribution {
  contributionChangeRequests?: ContributionChangeRequest[];
  amount?: number;
  accountId?: string;
}

interface Employer {
  id: string;
  status?: string;
  company: {
    name?: string;
    planId?: string;
  };
  group: {
    companyGroupIndex?: number;
  };
  contribution?: EmployerContribution;
  schedule: {
    end?: string;
  };
}

interface Account {
  id?: string;
  accountType?: string;
}

interface Props {
  linkedEmployers?: Employer[];
  // accountId is sourced from a still-loose selector that yields
  // `string | null | undefined`; accept null so the value passes through
  // unchanged.
  accountId?: string | null;
  accounts?: Account[];
}

interface State {
  showAddEmployerModal: boolean;
}

class Employers extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showAddEmployerModal: false,
    };
  }

  _getEmployerRows = () => {
    const employers = this.props.linkedEmployers;

    return map(employers, (employer) => {
      const contributionSource = {
        name: employer.company.name,
        planId: `${employer.company.planId}-${employer.group.companyGroupIndex}`,
        id: employer.id,
        isLinkRequest: !!employer.status, // only link requests have a status
      };

      let contributionInfo;

      if (!employer.contribution) {
        contributionInfo = {};
      } else {
        const pendingContribution = find(
          employer.contribution.contributionChangeRequests,
          (req) => req.status === "CHANGED"
        );

        const contributionAmount = pendingContribution
          ? pendingContribution.userNewContributionAmount
          : employer.contribution.amount;
        const targetIraAccountId = employer.contribution.accountId;
        const targetIraAccount = find(
          this.props.accounts,
          (account) => account.id === targetIraAccountId
        );

        contributionInfo = {
          schedule: "Per paycheck",
          end: employer.schedule.end,
          amount: contributionAmount,
          accountId: targetIraAccountId,
          accountType: get(targetIraAccount, "accountType"),
        };
      }

      return (
        <Col md={12} key={employer.id}>
          <ContributionSource
            isEmployer={true}
            contributionSource={contributionSource}
            contributionInfo={contributionInfo}
            employerLink={employer}
          />
        </Col>
      );
    });
  };
  render() {
    const employerRows = this._getEmployerRows();
    const canAddEmployer = isEmpty(employerRows);

    return (
      <div className="employers-container">
        <h1 className="section-title">Employer Plan</h1>
        {this.state.showAddEmployerModal && (
          <AddEmployerModal
            show={this.state.showAddEmployerModal}
            onClose={() => this.setState({ showAddEmployerModal: false })}
          />
        )}

        {employerRows}
        {canAddEmployer && (
          <Row>
            <Col md={6}>
              <ActionCard
                onClick={() => this.setState({ showAddEmployerModal: true })}
                icon={
                  <BsBriefcase size={16} strokeWidth={0.5} color={"#1D99A9"} />
                }
                title={"Link employer"}
                description={
                  "Link your employer account to set aside a portion of each paycheck"
                }
                actionText={"Link Employer Plan"}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default Employers;
